<template>
  <slot :disabled="disabled" />
</template>

<script>
const CardHeader = {
  name: "brCardHeader",
  props: {
    /**
     * Aplica estilo desabilitado ao componente
     */
    disabled: {
      type: Boolean,
      default: null,
    },
  },
}

export default CardHeader
</script>
